import { Component, inject } from '@angular/core';
import { ModalRef } from '@siemens/element-ng/modal';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-location-error',
    templateUrl: './location-error.component.html',
    styleUrls: ['./location-error.component.scss'],
    imports: [TranslateDirective, TranslatePipe]
})
export class LocationErrorComponent {
    private readonly modalRef = inject<ModalRef<unknown, string>>(ModalRef);

    onAccept(): void {
        this.modalRef.hide('accept');
    }
}
